import axios from "axios";
import url from "../config/urlServiceConfig";

const workflowAPI = {
  getTaskCenter: () => axios.get(url.taskCenter),
  getByID: (id) => axios.get(`UpdateKPIRequest/${id}`),
  submit: (body) => axios.post(`UpdateKPIValue`, body),
  getByKpiID: (id) => axios.get(`${url.request}/KPI/${id}`),
  doAction: (body) => axios.put(`${url.request}/DoAction`, body),
  getRequestByID: (id) => axios.get(`${url.request}/${id}`),
};

export default workflowAPI;
